export default "__VITE_ASSET__fd5420bc__"